import axios from 'axios';
import { API_CONFIG } from '../config/api';

const api = axios.create({
  baseURL: API_CONFIG.baseURL,
  timeout: API_CONFIG.timeout || 30000,
  headers: API_CONFIG.headers,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const messagingService = {
  list: async () => {
    const response = await api.get('/messages');
    return response.data;
  },
  listByPatient: async (patientId) => {
    const response = await api.get(`/messages/patient/${patientId}`);
    return response.data;
  },
  send: async (data) => {
    const response = await api.post('/messages', data);
    return response.data;
  },
  markRead: async (id) => {
    const response = await api.patch(`/messages/${id}/read`);
    return response.data;
  },
};

export default messagingService;
